import { z } from 'zod';

export const AgencyEmployeeAddressSchema = z.object({
  city: z.string().nullable(),
  country: z.string().nullable(),
  id: z.string().nullable(),
  postal: z.string().nullable(),
  province: z.string().nullable(),
  street: z.string().nullable(),
});

export const AgencyEmployeeSchema = z.object({
  cellphone: z.string().nullable(),
  email: z.string(),
  emailValidation: z.unknown().nullish(),
  firstName: z.string(),
  lastName: z.string().default('').nullish(), // to be removed after RPVAS-683
  lastVisitedDate: z.string(),
  middleName: z.string().nullish(),
  nationality: z.string().nullish(),
  phone: z.string(),
  profilePictureUrl: z.string().nullish(),
  address: AgencyEmployeeAddressSchema.nullish(),
});

export const AgencySchema = z.object({
  accessPortalEnabled: z.boolean(),
  activationEmailSentAt: z.string().nullish(),
  active: z.boolean(),
  agencyCertificateEligible: z.boolean().nullish(),
  agencyCertificateEligibleTip: z.string().nullish(),
  agreedToApplyboostTermsAndConditionsAt: z.string().nullish(),
  agreementSigned: z.boolean(),
  applyboostPartnerEnabled: z.boolean(),
  approvalDate: z.string().nullish(),
  autoAddNewSchools: z.boolean(),
  ccOnNoteCommunications: z.boolean(),
  ccStudents: z.boolean(),
  companyName: z.string(),
  displayId: z.number(),
  effectiveStaffLimit: z.number(),
  embeddedSearchDefaultCountry: z.array(z.string()).nullish(),
  embeddedSearchEnabled: z.boolean(),
  embeddedSearchVertical: z.boolean().nullish(),
  id: z.string().nullish(),
  intakeFormEnabled: z.boolean(),
  isOwner: z.boolean(),
  referralCode: z.string().nullish(),
  referralLink: z.string().nullish(),
  remainingLimit: z.number(),
  salesTier: z.string().nullish(),
  salesTierOverride: z.string().nullish(),
  schoolAgent: z.unknown().nullish(),
  studentsWithPaidApplication: z.number().nullable(),
  suspended: z.boolean(),
  website: z.string().nullish(),
  whatsappUsername: z.string().nullish(),
});
